export default __webpack_public_path__ + "static/media/woman-pointing.bac15ded.png";